import {useState, useEffect} from 'react';

import OptionsCard from "../OptionsCard/OptionsCard";

import styles from "./PaddingOptions.module.css"

export default function PaddingOptions(props) {
  return (
    <OptionsCard>
      <h3>Padding</h3>

      <label htmlFor="linkPadding">Link</label>

      <input type="checkbox" id="linkPadding" defaultChecked={props.linkedPadding} onChange={() => {props.setLinkedPadding(!props.linkedPadding)}} />

      {props.linkedPadding ? 
      <div className={styles.pixelValues}>
        <div>
          <label htmlFor="padding">Padding</label>
          <p><input type="number" id="padding" min={0} max={400} value={props.padding} onInput={(e) => {props.setPadding(e.target.value)}} />px</p>
        </div>
      </div>
      :
      <div className={styles.pixelValues}>
          <div>
            <label htmlFor="topPadding">Top</label>
            <p><input type="number" id="topPadding" min={0} max={400} value={props.topPadding} onInput={(e) => {props.setTopPadding(e.target.value)}} />px</p>
          </div>

          <div>
            <label htmlFor="leftPadding">Left</label>
            <p><input type="number" id="leftPadding" min={0} max={400} value={props.leftPadding} onInput={(e) => {props.setLeftPadding(e.target.value)}} />px</p>
          </div>

          <div>
            <label htmlFor="bottomPadding">Bottom</label>
            <p><input type="number" id="bottomPadding" min={0} max={400} value={props.bottomPadding} onInput={(e) => {props.setBottomPadding(e.target.value)}} />px</p>
          </div>
          
          <div>
            <label htmlFor="rightPadding">Right</label>
            <p><input type="number" id="rightPadding" min={0} max={400} value={props.rightPadding} onInput={(e) => {props.setRightPadding(e.target.value)}} />px</p>
          </div>
        </div>
      }
    </OptionsCard>
  );
}
